module.exports = __webpack_public_path__ + "img/Mstorybg201.d41c6b3e.png";